/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComponentTypeStatus } from './ComponentTypeStatus';
import {
    ComponentTypeStatusFromJSON,
    ComponentTypeStatusFromJSONTyped,
    ComponentTypeStatusToJSON,
    ComponentTypeStatusToJSONTyped,
} from './ComponentTypeStatus';

/**
 * 
 * @export
 * @interface ComponentTypeOneResponseDto
 */
export interface ComponentTypeOneResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ComponentTypeOneResponseDto
     */
    id: string;
    /**
     * Name of the ComponentType
     * @type {string}
     * @memberof ComponentTypeOneResponseDto
     */
    name: string;
    /**
     * Status of the ComponentType
     * @type {ComponentTypeStatus}
     * @memberof ComponentTypeOneResponseDto
     */
    status?: ComponentTypeStatus;
    /**
     * List of synonyms for this ComponentType
     * @type {Array<string>}
     * @memberof ComponentTypeOneResponseDto
     */
    synonyms: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ComponentTypeOneResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ComponentTypeOneResponseDto
     */
    updatedAt: Date;
    /**
     * Array of asset type IDs associated with this ComponentType
     * @type {Array<string>}
     * @memberof ComponentTypeOneResponseDto
     */
    componentClassCodes?: Array<string>;
}



/**
 * Check if a given object implements the ComponentTypeOneResponseDto interface.
 */
export function instanceOfComponentTypeOneResponseDto(value: object): value is ComponentTypeOneResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('synonyms' in value) || value['synonyms'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ComponentTypeOneResponseDtoFromJSON(json: any): ComponentTypeOneResponseDto {
    return ComponentTypeOneResponseDtoFromJSONTyped(json, false);
}

export function ComponentTypeOneResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComponentTypeOneResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': json['status'] == null ? undefined : ComponentTypeStatusFromJSON(json['status']),
        'synonyms': json['synonyms'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'componentClassCodes': json['componentClassCodes'] == null ? undefined : json['componentClassCodes'],
    };
}

export function ComponentTypeOneResponseDtoToJSON(json: any): ComponentTypeOneResponseDto {
    return ComponentTypeOneResponseDtoToJSONTyped(json, false);
}

export function ComponentTypeOneResponseDtoToJSONTyped(value?: ComponentTypeOneResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'status': ComponentTypeStatusToJSON(value['status']),
        'synonyms': value['synonyms'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'componentClassCodes': value['componentClassCodes'],
    };
}

